var _defs, _g, _g2, _g3, _g4, _g5, _g6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGumballs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gumballs",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 814 1600",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .panel, .blue { fill: #3aa7c2; } \n      .black, .qq, .hole { fill: #191a1a; } \n      .qq { opacity: 0.5; } \n      .green { fill: #4d995c; } \n      .orange { fill: #f7a747; } \n      .lip, .red { fill: #e66f51; } \n      .yellow { fill: #ffcc67; } \n      .burned { fill: #ad533d; } \n      .lip, .hole { stroke: #ad533d; stroke-width: 12px; } \n      .lip, .panel, .glass, .glare, .hole { stroke-miterlimit: 10; } \n      .panel { stroke: #f6f8f9; stroke-width: 10px; } \n      .maized { fill: #bf994d; } \n      .mask { clip-path: url(#clip-path); } \n      .pale { opacity: 0.25; } \n      .white { fill: #f6f8f9; } \n      .glass, .glare { stroke: #3aa7c2; } \n      .glass { fill: none; stroke-width: 8px; } \n      .glare { fill: #d8edf3; stroke-width: 3px; opacity: 0.75; }\n    "), /*#__PURE__*/React.createElement("symbol", {
    id: "gumball-yellow",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "yellow",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "rotate(-45 48 48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qq",
    d: "M41 55a1 1 0 01-1 0 2 2 0 010-2 13 13 0 011-3 27 27 0 013-4l3-3a22 22 0 003-2 3 3 0 000-3 2 2 0 00-1-1c-1-1-4-1-5 2a5 5 0 01-1 1 2 2 0 01-2 1H28a2 2 0 01-1-1 2 2 0 01-1-1 13 13 0 012-6 17 17 0 014-5 21 21 0 017-4c5-2 15-2 21 0a16 16 0 016 3 13 13 0 013 5 12 12 0 010 8 14 14 0 01-2 4 31 31 0 01-2 3l-3 3-2 2a5 5 0 01-1 1 13 13 0 01-1 2 2 2 0 01-2 0zm1 19a2 2 0 01-2-2V60a2 2 0 012-2h13a2 2 0 012 2v12a2 2 0 01-2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "gumball-green",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "green",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "rotate(-45 48 48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qq",
    d: "M41 55a1 1 0 01-1 0 2 2 0 010-2 13 13 0 011-3 27 27 0 013-4l3-3a22 22 0 003-2 3 3 0 000-3 2 2 0 00-1-1c-1-1-4-1-5 2a5 5 0 01-1 1 2 2 0 01-2 1H28a2 2 0 01-1-1 2 2 0 01-1-1 13 13 0 012-6 17 17 0 014-5 21 21 0 017-4c5-2 15-2 21 0a16 16 0 016 3 13 13 0 013 5 12 12 0 010 8 14 14 0 01-2 4 31 31 0 01-2 3l-3 3-2 2a5 5 0 01-1 1 13 13 0 01-1 2 2 2 0 01-2 0zm1 19a2 2 0 01-2-2V60a2 2 0 012-2h13a2 2 0 012 2v12a2 2 0 01-2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "gumball-orange",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "orange",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "rotate(-45 48 48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qq",
    d: "M41 55a1 1 0 01-1 0 2 2 0 010-2 13 13 0 011-3 27 27 0 013-4l3-3a22 22 0 003-2 3 3 0 000-3 2 2 0 00-1-1c-1-1-4-1-5 2a5 5 0 01-1 1 2 2 0 01-2 1H28a2 2 0 01-1-1 2 2 0 01-1-1 13 13 0 012-6 17 17 0 014-5 21 21 0 017-4c5-2 15-2 21 0a16 16 0 016 3 13 13 0 013 5 12 12 0 010 8 14 14 0 01-2 4 31 31 0 01-2 3l-3 3-2 2a5 5 0 01-1 1 13 13 0 01-1 2 2 2 0 01-2 0zm1 19a2 2 0 01-2-2V60a2 2 0 012-2h13a2 2 0 012 2v12a2 2 0 01-2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "gumball-blue",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "blue",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "rotate(-45 48 48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qq",
    d: "M41 55a1 1 0 01-1 0 2 2 0 010-2 13 13 0 011-3 27 27 0 013-4l3-3a22 22 0 003-2 3 3 0 000-3 2 2 0 00-1-1c-1-1-4-1-5 2a5 5 0 01-1 1 2 2 0 01-2 1H28a2 2 0 01-1-1 2 2 0 01-1-1 13 13 0 012-6 17 17 0 014-5 21 21 0 017-4c5-2 15-2 21 0a16 16 0 016 3 13 13 0 013 5 12 12 0 010 8 14 14 0 01-2 4 31 31 0 01-2 3l-3 3-2 2a5 5 0 01-1 1 13 13 0 01-1 2 2 2 0 01-2 0zm1 19a2 2 0 01-2-2V60a2 2 0 012-2h13a2 2 0 012 2v12a2 2 0 01-2 2z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "gumball-red",
    viewBox: "0 0 96 96"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "red",
    cx: 48,
    cy: 48,
    r: 48,
    transform: "rotate(-45 48 48)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "qq",
    d: "M41 55a1 1 0 01-1 0 2 2 0 010-2 13 13 0 011-3 27 27 0 013-4l3-3a22 22 0 003-2 3 3 0 000-3 2 2 0 00-1-1c-1-1-4-1-5 2a5 5 0 01-1 1 2 2 0 01-2 1H28a2 2 0 01-1-1 2 2 0 01-1-1 13 13 0 012-6 17 17 0 014-5 21 21 0 017-4c5-2 15-2 21 0a16 16 0 016 3 13 13 0 013 5 12 12 0 010 8 14 14 0 01-2 4 31 31 0 01-2 3l-3 3-2 2a5 5 0 01-1 1 13 13 0 01-1 2 2 2 0 01-2 0zm1 19a2 2 0 01-2-2V60a2 2 0 012-2h13a2 2 0 012 2v12a2 2 0 01-2 2z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 407,
    cy: 450,
    r: 350
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "burned",
    d: "M784 1506c-132 133-605 118-751 0-46-37-42-194 0-236 133-133 633-147 751 0 37 46 42 194 0 236z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "red",
    d: "M719 1399c-101 134-525 135-625 0-99-132 105-679 105-679h422s197 548 98 679z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mouth"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hole",
    d: "M332 1230h150v260H332z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lip",
    d: "M542 1516c-46 34-218 30-269 0-31-19-28-131 0-114 61 35 208 35 269 0 28-17 28 93 0 114z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "panel",
    d: "M501 1242c-191-1-210 10-223-24-4-3-1-197-2-270 1-17-3-32 9-46 17-23 72-10 146-13 78-1 105-5 106 40-3 291 15 307-36 313z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "slot"
  }, /*#__PURE__*/React.createElement("path", {
    className: "yellow",
    d: "M446 1002c-3 54-77 50-78 0 3-54 77-50 78 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maized",
    d: "M435 1002c-2 39-55 35-56 0 2-39 55-35 56 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "black",
    d: "M387 996h40v12h-40z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "crank"
  }, /*#__PURE__*/React.createElement("path", {
    className: "yellow",
    d: "M439 1141c-3 45-63 41-64 0 3-45 63-41 64 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maized",
    d: "M429 1141c-2 31-43 28-44 0 2-31 43-28 44 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "yellow",
    d: "M497 1123a18 18 0 00-15 8H332a18 18 0 100 20h150a18 18 0 1015-28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "maized",
    d: "M413 1141c0 7-11 9-12 0 0-7 11-9 12 0z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "globe"
  }, /*#__PURE__*/React.createElement("g", {
    className: "mask"
  }, /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(5 -391 3142)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-10 668 -1838)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(15 -116 1646)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-20 474 -508)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(25 -215 461)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-30 487 -782)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(35 106 971)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-40 585 -699)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(45 18 458)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-5 2103 -3913)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(10 -768 2567)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-15 1042 -1718)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(20 -402 762)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-25 568 -76)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(30 -218 711)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-35 621 -432)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(40 13 918)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-45 592 -378)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(5 -2468 7340)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-10 1476 -743)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(15 -967 382)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-20 949 -135)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(25 -452 717)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-30 764 -394)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(35 -71 1262)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(20 -523 1669)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(45 -30 908)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-5 3830 -1944)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-15 1409 42)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(20 -655 1315)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-25 983 -358)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(30 -487 865)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-35 708 52)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(40 -196 849)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-15 1714 -2186)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(5 -3789 8339)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-10 2417 -2872)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(15 -1290 1773)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-20 1290 -283)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(25 -906 281)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-30 907 128)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(35 -621 508)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-40 780 -104)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(45 -136 1078)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-5 5019 -5265)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(10 -2419 2199)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-15 2056 -1322)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(20 -825 1959)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-25 1351 -953)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(30 -549 1440)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-35 1090 -476)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(40 -310 1239)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-45 673 266)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(5 -5760 6830)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-10 3062 -235)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(15 -1699 1097)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-20 1666 -491)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(25 -1122 695)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-30 1226 -368)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(35 -622 1014)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-40 1109 -366)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(45 -622 432)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-5 6930 -7006)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(10 -3126 1685)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-15 2472 -846)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(20 -1650 751)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-25 1590 -100)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(30 -914 1080)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-35 1321 -572)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(40 -717 756)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-45 1054 -195)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(5 -7354 6578)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-10 4117 -1571)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(15 -2524 970)",
    xlinkHref: "#gumball-blue"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-20 2250 -786)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(25 -1468 914)",
    xlinkHref: "#gumball-orange"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-30 1651 -500)",
    xlinkHref: "#gumball-yellow"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(35 -982 890)",
    xlinkHref: "#gumball-red"
  }), /*#__PURE__*/React.createElement("use", {
    width: 96,
    height: 96,
    transform: "rotate(-40 1283 -88)",
    xlinkHref: "#gumball-green"
  }), /*#__PURE__*/React.createElement("path", {
    className: "pale white",
    d: "M416 18c79 0 155 17 185 53 20 26 23 108 0 131-33 33-108 48-184 48-80 0-163-17-202-48-25-21-23-107 0-131 35-34 119-53 201-53m0-8v8-8c-42 0-84 5-120 14-39 10-69 24-86 42-10 9-15 25-17 36a182 182 0 00-4 47c2 38 14 54 21 59 20 16 50 29 89 37a541 541 0 00228 1c36-9 62-22 79-38 7-7 12-17 15-31a167 167 0 004-40c0-23-5-55-18-71-15-18-42-33-78-43-32-8-71-13-113-13z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "pale white",
    d: "M407 100a350 350 0 110 700 350 350 0 010-700m0-12a362 362 0 00-141 696 362 362 0 00282-668 360 360 0 00-141-28z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "glass",
    cx: 407,
    cy: 450,
    r: 350
  }), /*#__PURE__*/React.createElement("path", {
    className: "glare",
    d: "M97 432c-18-36 16-130 49-152 12-8 45 4 52 16 8 18-41 37-50 68-10 32 19 77 0 85-13 4-45-5-51-17z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "cap"
  }, /*#__PURE__*/React.createElement("path", {
    className: "red",
    d: "M601 202c-69 68-311 60-386 0-25-21-23-107 0-131 68-67 325-74 386 0 20 26 23 108 0 131z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "burned",
    d: "M582 72c-8 71-342 70-350 1 6-71 344-70 350-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "red",
    d: "M462 48c-19 17-88 15-110 0-7-6-6-28 0-34 20-18 93-19 110 0 6 6 7 28 0 34z"
  }))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgGumballs);
export default ForwardRef;